import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type LoadingMessageProps = {
  message: string;
};

const LoadingIcon = (
  <LoadingOutlined style={{ color: 'white', fontSize: 18 }} spin />
);

const LoadingMessage = ({ message }: LoadingMessageProps) => {
  return (
    <Main>
      <Icon>
        <Spin indicator={LoadingIcon} />
      </Icon>
      <Message>{message}</Message>
    </Main>
  );
};

export { LoadingMessage };

const Main = styled.div`
  z-index: 10;
  position: fixed;
  top: 80px;
  left: calc(50% - 110px);
  width: 220px;
  height: 40px;
  background: #5b85e8 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 12px #00000026;
  border-radius: 2px;
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  position: absolute;
  left: 12px;
`;

const Message = styled.div`
  color: white;
  left: 0;
  right: 0;
  margin: auto;
`;
